import type { GenderEnum } from '@gql/graphql';
import type { Dayjs } from 'dayjs';
import type { LocationDescriptor } from 'history';
import type { MouseEventHandler } from 'react';

export interface MtBookingCardDataAnimal {
  name: string;
  image?: string;
  gender?: GenderEnum;
  birthday?: Dayjs;
  link: LocationDescriptor;
}

export interface MtBookingCardDataPro {
  name: string;
  email?: string;
  phone?: string;
  image?: string;
  link: LocationDescriptor;
}

// export type RenderUpdateModal = (
//   prefillValues: BookingFormPrefillValues & { proId: number; bookingId: number },
// ) => ReactElement;

export interface MtBookingCardDataBooking {
  animals: MtBookingCardDataAnimal[];
  pro: MtBookingCardDataPro;
  id: number;
  startDate: Dayjs;
  endDate: Dayjs;
  duration: string;
  service: string;
  warning?: string;
  canUpdate: boolean;
}

export interface MtBookingCardData {
  upcoming?: boolean;

  booking: MtBookingCardDataBooking;

  onDeleteClick?: MouseEventHandler;
  onUpdateClick?: MouseEventHandler;
  onClick?: MouseEventHandler;
}

export interface MtBookingCardProps extends MtBookingCardData {}
